import { computed } from 'vue'

const ageRanges = {
  male: {
    young: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fmale-young.avif?alt=media&token=d01de711-6527-48fb-98c3-eefd0a3043a9',
    adult: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fmale-adult.avif?alt=media&token=b96768fa-5231-4cc6-9d65-263b7ae92271',
    mature: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fmale-mature.avif?alt=media&token=fe273782-c2b5-4592-8b9b-07932d1da284',
    old: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fmale-old.avif?alt=media&token=5f1e3f5d-59a6-4222-a13b-acceccd7f3b6'
  },
  female: {
    young: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Ffemale-young.avif?alt=media&token=5e6def16-8c17-4681-99e1-22c116538735',
    adult: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Ffemale-adult.avif?alt=media&token=cf8be9c7-6d31-410a-a511-bce84b148817',
    mature: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Ffemale-mature.avif?alt=media&token=1254a5a2-1cde-4f8e-a3be-6d6583e75b41',
    old: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Ffemale-old.avif?alt=media&token=3727f96a-c6e1-495a-a033-f98b5f358b51'
  }
}

export function useAgeImage(gender: 'male' | 'female', age: any) {
  const currentImage = computed(() => {
    if (!age.value) return null
    
    const images = ageRanges[gender]
    if (age.value < 30) return images.young
    if (age.value < 40) return images.adult
    if (age.value < 50) return images.mature
    return images.old
  })

  return {
    currentImage
  }
}